let getAmountOfOrderAndSale;
function initDisabledTooltips() {
	console.log('tool');

	$('.return-order-button').each(function () {
		if ($(this).is(':disabled')) {
			$(this).attr('title', 'Verifone-integrasjon er deaktivert. Returordre kan ikke behandles.');
		} else {
			$(this).attr('title', '');
		}
	});
}

$(document).ready(function () {
	let filterByFromQuery = $('body').attr('filter_by') || null;
	let startDateFromQuery = $('body').attr('start_date') || null;
	let endDateFromQuery = $('body').attr('end_date') || null;
	let customPeriodFromQuery = $('body').attr('custom_period') || null;
	let prevSelectedPeriodFromQuery = $('body').attr('prev_selected_period') || null;

	if (p == 'order_confirmation' || p == 'organizer_event_customers' || p == 'statistic_order') {
		if (localStorage.getItem('returningOrderData')) {
			const { orderId, addStockBack, returnedOrderId } = JSON.parse(localStorage.getItem('returningOrderData'));
			getOrderPaymentSplitModal(orderId, addStockBack, returnedOrderId, true);
		}

		$(document).on('click', '.return-order-button', function () {
			const orderIdToReturn = $(this).attr('data-order-id');
			const paymentMethodToReturn = $(this).attr('data-payment-method');
			const terminalId = $(this).attr('data-terminal-id') || null;

			if ($('body').attr('is_verifone') && localStorage.getItem('verifoneSerialNumber') && terminalId) {
				const verifoneSerialNumber = localStorage.getItem('verifoneSerialNumber');

				if (verifoneSerialNumber !== terminalId) {
					showToast({
						type: 'warning',
						title: 'Retur ikke tillatt !',
						message: `Bestillingen ble opprettet på en annen enhet. Bruk original enhet for retur`,
						duration: 4000,
					});
					return;
				}
			}

			$('.return-order-confirm-btn').attr('data-order-id', orderIdToReturn);
			$('.return-order-confirm-btn').attr('data-payment-method', paymentMethodToReturn);
			$('#return-order-model').modal('show');
		});

		$(document).on('click', '.return-order-confirm-btn', function (e) {
			e.preventDefault();

			const orderId = $(this).attr('data-order-id');
			const addStockBack = $(this).attr('data-add-back-stock');
			const paymentMethod = $(this).attr('data-payment-method');
			const returnedOrderId = $('#returnOrderPaymentSplitModel').attr('data-returned-order-id') || null;

			if (paymentMethod == 9) {
				getOrderPaymentSplitModal(orderId, addStockBack, returnedOrderId);
			} else {
				$('#return-order-model').modal('hide');
				const retryButton = $('.return-order-retry-btn');
				$('.return-order-progress-section').removeClass('d-none');
				$('.return-order-success-section').addClass('d-none');
				$('.return-order-success-section').addClass('d-none');
				$('.return-error-message-section').addClass('d-none');
				$('.return-order-progress-action-btn').prop('disabled', true);
				$('#return-order-progress-model').modal('show');
				retryButton.attr('data-order-id', orderId);
				retryButton.attr('data-add-back-stock', addStockBack);

				returnOrder(orderId, addStockBack);
			}
		});

		$(document).on('click', '.order-payment-split-return-button', function (e) {
			e.preventDefault();
			const terminalId = $(this).attr('data-terminal-id') || null;
			if ($('body').attr('is_verifone') && localStorage.getItem('verifoneSerialNumber') && terminalId) {
				const verifoneSerialNumber = localStorage.getItem('verifoneSerialNumber');

				if (verifoneSerialNumber !== terminalId) {
					showToast({
						type: 'warning',
						title: 'Retur ikke tillatt !',
						message: `Bestillingen ble opprettet på en annen enhet. Bruk original enhet for retur`,
						duration: 4000,
					});
					return;
				}
			}

			const orderId = $(this).attr('data-order-id');
			const orderPaymentSplitId = $(this).attr('data-order-payment-split-id');
			const addStockBack = $(this).attr('data-add-back-stock');
			const paymentMethod = $(this).attr('data-payment-method');
			const parentDiv = $(this).closest('.order-payment-split-return-section');
			const returnedOrderId = $('#returnOrderPaymentSplitModel').attr('data-returned-order-id') || null;
			const button = $(this);
			const btnWidth = button.outerWidth();
			button.css('width', btnWidth + 'px');
			button.prop('disabled', true);
			$('.order-payment-split-return-button').prop('disabled', true);
			button.html('<i class="spinner-border spinner-border-sm"></i>');

			$.ajax({
				type: 'POST',
				url: '/api/v1/private/order/return-order-payment-split',
				data: {
					orderId,
					orderPaymentSplitId,
					addStockBack,
					paymentMethod,
					returnedOrderId,
				},
			})
				.done(function (data) {
					button.removeClass('btn-primary');
					button.addClass('btn-success');
					button.html('✓');
					if (data && data.isFullyReturned) {
						localStorage.removeItem('returningOrderData');
						$('#returnOrderPaymentSplitModel').modal('hide');
						popupAlert();
						if (p == 'statistic_order') {
							getAmountOfOrderAndSale(
								startDate,
								endDate,
								period,
								supplierId,
								productGroupUniqueId,
								locationId,
								userId,
								platform,
								customPeriod,
								topProductGroupUniqueId,
								customerId,
								compareBy,
								productId,
								vatCode,
								paymentMethod
							);
							$('.modal-backdrop').remove();
						} else if (data && data.redirect_url && data.success) {
							document.location.href = data.redirect_url;
						}
					} else if (data && data.returnedOrderId && !data.refund_data) {
						$('#returnOrderPaymentSplitModel .close').addClass('d-none');
						$('#returnOrderPaymentSplitModel').attr('data-returned-order-id', data.returnedOrderId);
						localStorage.setItem(
							'returningOrderData',
							JSON.stringify({
								orderId,
								addStockBack,
								returnedOrderId: data.returnedOrderId,
							})
						);
						button.attr('data-is-paid', 1);

						$(".order-payment-split-return-button[data-is-paid='0']").prop('disabled', false);
						button.prop('disabled', true);
						$('.return-order-error').remove();
					} else if (data && data.refund_data) {
						localStorage.setItem('verifone_refund_data', JSON.stringify(data.refund_data));

						if ($('body').attr('is_verifone')) {
							passVerifoneDataToWebView(data.refund_data);
						} else {
							const payload = {
								type: 'verifone',
								action: 'start_refund',
								verifoneSerialNumber: data.refund_data.verifoneId,
								paymentData: data.refund_data,
								senderDeviceId: localStorage.getItem('deviceID'),
							};

							window.globalSocket.send(JSON.stringify(payload));
						}
					}
				})
				.fail(function (data) {
					button.html('Retur');
					button.prop('disabled', false);
					let errorMessage = 'An error occured';

					if (data.responseJSON.errors !== undefined && data.responseJSON.errors !== null) {
						errorMessage = data.responseJSON.errors;
					}

					const alertDiv = `<div class="alert alert-danger alert-dismissible return-order-error" role="alert">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>
                                ${errorMessage}
                             </div>`;
					parentDiv.after(alertDiv);
				});
		});

		$(document).on('click', '.return-order-retry-btn', function (e) {
			e.preventDefault();
			const orderId = $(this).attr('data-order-id');
			const addStockBack = $(this).attr('ddata-add-back-stock');
			$('.return-order-progress-section').removeClass('d-none');
			$('.return-error-message-section').addClass('d-none');
			returnOrder(orderId, addStockBack);
		});

		$(document).on('click', '.back-to-return-order', function () {
			$('#return-order-model').modal('show');
			$('#return-order-progress-model').modal('hide');
		});

		function returnOrder(orderId, addStockBack) {
			$.ajax({
				type: 'POST',
				url: '/api/v1/private/order/return-order',
				data: { orderId, addStockBack },
			})
				.done(function (data) {
					if (data && data.success) {
						$('.return-order-success-section ').removeClass('d-none');
						$('.return-order-progress-section').addClass('d-none');

						setTimeout(() => {
							if (p == 'statistic_order') {
								getAmountOfOrderAndSale(
									startDate,
									endDate,
									period,
									supplierId,
									productGroupUniqueId,
									locationId,
									userId,
									platform,
									customPeriod,
									topProductGroupUniqueId,
									customerId,
									compareBy,
									productId,
									vatCode,
									paymentMethod
								);
								$('.modal-backdrop').remove();
							} else if (data.redirect_url) {
								document.location.href = data.redirect_url;
							}
						}, 1000);
					} else if (data && data.refund_data) {
						localStorage.setItem('verifone_refund_data', JSON.stringify(data.refund_data));
						if ($('body').attr('is_verifone')) {
							passVerifoneDataToWebView(data.refund_data);
						} else {
							const payload = {
								type: 'verifone',
								action: 'start_refund',
								verifoneSerialNumber: data.refund_data.verifoneId,
								paymentData: data.refund_data,
								senderDeviceId: localStorage.getItem('deviceID'),
							};

							window.globalSocket.send(JSON.stringify(payload));
						}
					}
				})
				.fail(function (data) {
					if (data.responseJSON.errors !== undefined && data.responseJSON.errors !== null) {
						let errorMessage = '';
						if (data.responseJSON.errors.includes('/')) {
							errorMessage = data.responseJSON.errors.split('/')[0];
						} else {
							errorMessage = data.responseJSON.errors;
						}

						$('.return-order-progress-section').addClass('d-none');
						$('.return-error-message-section').removeClass('d-none');
						$('.return-error-message-section .return-error-message').text(errorMessage);
					}
				})
				.always(function () {
					$('.return-order-progress-action-btn').prop('disabled', false);
				});
		}

		function getOrderPaymentSplitModal(orderId, addStockBack, returnedOrderId, disbaledClose = false) {
			$.ajax({
				type: 'POST',
				url: '/api/v1/private/order/get-order-payment-split-return-modal',
				data: { orderId, addStockBack, returnedOrderId },
			})
				.done(function (data) {
					if (data.html) {
						$('#return-order-model').modal('hide');
						if ($('#returnOrderPaymentSplitModel').length) {
							$('#returnOrderPaymentSplitModel').remove();
						}
						$('#content').append(data.html);
						$('#returnOrderPaymentSplitModel').modal('show');
						if (disbaledClose) {
							$('#returnOrderPaymentSplitModel .close').remove();
						}
					}
				})
				.fail(function (data) {});
		}
	}

	if (p === 'statistic_order') {
		setDateAndPeriod(
			startDateFromQuery,
			endDateFromQuery,
			filterByFromQuery,
			customPeriodFromQuery,
			prevSelectedPeriodFromQuery
		);
		handleCustomerIdChange(getAmountOfOrderAndSale);
		handleCustomPeriodChange(getAmountOfOrderAndSale);
		handleTopProductGroupChange(getAmountOfOrderAndSale);
		handleSupplierIdChange(getAmountOfOrderAndSale);
		handleProductGroupChange(getAmountOfOrderAndSale);
		handleUserChange(getAmountOfOrderAndSale);
		handlePlatformChange(getAmountOfOrderAndSale);
		handlePeriodChange(getAmountOfOrderAndSale);
		handleDateAndTimeChange(getAmountOfOrderAndSale);
		handlePreviousButton(getAmountOfOrderAndSale);
		handleNextButton(getAmountOfOrderAndSale);
		handleCompareByChange(getAmountOfOrderAndSale);
		handleProductChange(getAmountOfOrderAndSale);
		handlePaymentChange(getAmountOfOrderAndSale);
		handleVatCodeChange(getAmountOfOrderAndSale);
		handleLocationChange(getAmountOfOrderAndSale);
		handleCustomDayChange(getAmountOfOrderAndSale);
		handleProductCategoryChange(getAmountOfOrderAndSale);
		let total1 = 0;
		let exportDateData = [];
		let exportOrderData = [];
		let htmlData = [];

		$(document).on('click', '#download-statistic-excel', function () {
			const disabledOnClick = $(this);
			const btnWidth = disabledOnClick.outerWidth();
			disabledOnClick.css('width', btnWidth + 'px');
			disabledOnClick.prop('disabled', true);
			disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');
			htmlData = getOrderHtmlData();
			$.ajax({
				url: '/api/v1/private/statistics/download-statistic-excel',
				method: 'POST',
				contentType: 'application/json',
				data: JSON.stringify({
					export_date_data: exportDateData,
					export_order_data: exportOrderData,
					start_date: startDate,
					end_date: endDate,
					export_type: 'order',
					html_data: htmlData,
					total_order: total1,
				}),
				xhrFields: { responseType: 'blob' }, // important for binary data
				success: function (data) {
					// Check if running in React Native WebView
					if (window.ReactNativeWebView) {
						// Convert blob to base64
						const reader = new FileReader();
						reader.onloadend = function () {
							const base64Data = reader.result.split(',')[1];
							const filename = `Statistikk ordre (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).xlsx`;

							// Send to React Native
							window.ReactNativeWebView.postMessage(
								JSON.stringify({
									action: 'download',
									data: {
										base64Data,
										filename: filename,
										mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
									},
								})
							);
						};
						reader.readAsDataURL(data);
					} else {
						// Standard browser download
						const blob = new Blob([data], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
						});
						const link = document.createElement('a');
						link.href = URL.createObjectURL(blob);
						link.download = `Statistikk ordre (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).xlsx`;
						link.click();
					}
				},
				error: function () {
					alert('Error generating Excel file');
				},
				complete: function () {
					disabledOnClick.prop('disabled', false);
					disabledOnClick.html('Last ned(excel)');
				},
			});
		});

		$(document).on('click', '#download-statistic-pdf', function () {
			const disabledOnClick = $(this);
			const btnWidth = disabledOnClick.outerWidth();
			disabledOnClick.css('width', btnWidth + 'px');
			disabledOnClick.prop('disabled', true);
			disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');
			htmlData = getOrderHtmlData();
			if (!chartComponent) {
				alert('Chart not ready');
				disabledOnClick.prop('disabled', false).html('Last ned(pdf)');
				return;
			}

			// Convert Highcharts SVG to PNG
			const svg = chartComponent.getSVG();
			const img = new Image();
			img.onload = function () {
				const canvas = document.createElement('canvas');
				canvas.width = img.width;
				canvas.height = img.height;
				const ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0);
				const pngData = canvas.toDataURL('image/png'); // base64 PNG

				// Prepare payload using your Excel-style fields + chart PNG
				const payload = {
					export_date_data: exportDateData,
					export_order_data: exportOrderData,
					export_type: 'order',
					html_data: htmlData,
					total_order: total1,
					chart_png: pngData, // PNG included
				};

				// AJAX POST to generate PDF
				$.ajax({
					url: '/api/v1/private/statistics/download-statistic-pdf',
					method: 'POST',
					contentType: 'application/json',
					data: JSON.stringify(payload),
					xhrFields: { responseType: 'blob' }, // receive PDF
					success: function (data) {
						if (window.ReactNativeWebView) {
							// Convert blob to base64
							const reader = new FileReader();
							reader.onloadend = function () {
								const base64Data = reader.result.split(',')[1]; // Remove data:*/*;base64, prefix
								const filename = `Statistikk ordre (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).pdf`;

								// Send to React Native
								window.ReactNativeWebView.postMessage(
									JSON.stringify({
										action: 'download',
										data: {
											base64Data,
											filename: filename,
											mimeType: 'application/pdf',
										},
									})
								);
							};
							reader.readAsDataURL(data);
						} else {
							const blob = new Blob([data], { type: 'application/pdf' });
							const link = document.createElement('a');
							link.href = URL.createObjectURL(blob);
							link.download = `Statistikk ordre (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).pdf`;
							link.click();
						}
					},
					error: function () {
						alert('Error generating PDF');
					},
					complete: function () {
						disabledOnClick.prop('disabled', false);
						disabledOnClick.html('Last ned(pdf)');
					},
				});
			};

			// Encode SVG for PNG conversion
			img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
		});

		function getOrderHtmlData() {
			let htmlData = [];
			$('.mobile-view .list-group').each(function () {
				let $li = $(this).find('li');

				let table = $li.eq(0).text().replace('Bord :', '').trim();
				let ref = $li.eq(1).text().replace('Ref :', '').trim();
				let date = $li.eq(2).text().replace('Dato :', '').trim();
				let order = [];
				$li.eq(3)
					.find('.product-name p')
					.each(function () {
						let text = $(this).text().replace(/\s+/g, ' ').trim();
						order.push(text);
					});
				let totalText = $li
					.eq(4)
					.text()
					.replace('Totalt:', '')
					.replace(/\s+/g, '')
					.replace('kr', '')
					.replace(',', '.');
				let total = parseFloat(totalText);

				htmlData.push({ table, ref, date, order, total });
			});
			return htmlData;
		}

		function eventLineChart(categoryArray, seriesData1, seriesData2) {
			const { legendText, previousLegendText } = getLegendTexts(compareBy, startDate);
			// Calculate totals
			total1 = seriesData1.reduce((sum, val) => sum + floor(val), 0);
			const total2 = seriesData2 ? seriesData2.reduce((sum, val) => sum + floor(val), 0) : 0;

			chartComponent = Highcharts.chart('event-line-graph', {
				chart: {
					type: 'column',
				},
				title: {
					text: null,
				},

				exporting: {
					enabled: false,
					buttons: {
						contextButton: {
							menuItems: [
								{
									text: 'Last ned PDF',
									onclick: function () {
										this.exportChart({ type: 'application/pdf' });
									},
								},
								{
									text: 'Last ned Excel',
									onclick: function () {
										const chart = this;

										// Get the default table
										const table = chart.getTable();

										// Parse the existing table to extract data
										const parser = new DOMParser();
										const doc = parser.parseFromString(table, 'text/html');
										const rows = doc.querySelectorAll('tr');

										let csvContent = '';

										// Add BOM for proper UTF-8 encoding in Excel
										csvContent = '\uFEFF';

										// Add custom header rows
										csvContent += 'Statistikk: Ordrebeløp \n';
										csvContent += startDate + ' - ' + endDate + '\n';
										csvContent += 'Generert:,' + new Date().toLocaleString('no-NO') + '\n';
										csvContent += '\n'; // Empty row

										// Add table header and data rows
										rows.forEach((row, index) => {
											const cells = row.querySelectorAll('th, td');
											const rowData = [];

											cells.forEach((cell) => {
												let cellText = cell.textContent.trim();
												// Fix the "Chart" header issue
												if (cellText === 'Chart' || cellText === 'Category') {
													cellText = 'Dato';
												}
												rowData.push(cellText);
											});

											if (rowData.length > 0) {
												csvContent += rowData.join(',') + '\n';
											}
										});

										// Add custom footer rows
										csvContent += 'Totalt,' + total1 + '\n';
										csvContent += '\n';
										csvContent += 'Dato,' + 'Ordre' + ',' + 'Totalt' + '\n';
										csvContent +=
											'"12/09/2025 18:23:34",' +
											'"2 x cake\n1 x cola\n1 x tea",' +
											'"173 kr"' +
											'\n';

										if (seriesData2 && total2 > 0) {
											csvContent +=
												'Totalt forrige ' +
												getPeriodTranslation(compareBy ?? '', startDate) +
												',' +
												total2 +
												'\n';
										}

										// Create and download the file with proper UTF-8 encoding
										const blob = new Blob([csvContent], {
											type: 'text/csv;charset=utf-8;',
										});
										const link = document.createElement('a');
										const url = URL.createObjectURL(blob);
										link.setAttribute('href', url);
										link.setAttribute(
											'download',
											'Ordrebeløp_' +
												startDate.replace(/[^a-zA-Z0-9]/g, '_') +
												'_' +
												endDate.replace(/[^a-zA-Z0-9]/g, '_') +
												'.csv'
										);
										link.style.visibility = 'hidden';
										document.body.appendChild(link);
										link.click();
										document.body.removeChild(link);
										URL.revokeObjectURL(url);
									},
								},
							],
						},
					},
				},

				plotOptions: {
					series: {
						lineWidth: 4,
					},
				},
				xAxis: {
					categories: categoryArray,
					labels: {
						formatter: function () {
							if (customPeriod === 'day') {
								return Highcharts.dateFormat('%e/%b', new Date(this.value).getTime());
							} else if (customPeriod === 'week') {
								return 'Uke ' + this.value;
							} else if (customPeriod === 'month') {
								return Highcharts.dateFormat('%B %Y', new Date(this.value).getTime());
							} else {
								return this.value;
							}
						},
					},
				},
				credits: { enabled: false },
				yAxis: {
					title: {
						text: 'Ordrebeløp',
					},
				},
				series:
					!compareBy || compareBy == '0'
						? [
								{
									name: 'Ordrebeløp',
									data: seriesData1.map((value, index) => [categoryArray[index], floor(value)]),
								},
							]
						: [
								{
									name: `Ordrebeløp ( ${total1} ) ${legendText}`,
									data: seriesData1.map((value, index) => [categoryArray[index], floor(value)]),
								},
								{
									name: `Ordrebeløp forrige ${getPeriodTranslation(
										compareBy ?? '',
										startDate
									)} ( ${total2} ) ${previousLegendText}`,
									data: seriesData2.map((value, index) => [categoryArray[index], floor(value)]),
								},
							],
				tooltip: {
					formatter: function () {
						var tooltipText;
						if (startDate.split(' ')[0] === endDate.split(' ')[0]) {
							tooltipText =
								'<b>' +
								Highcharts.dateFormat('%H:%M, %b %e', this.x) +
								'</b><br/>' +
								'Handler : ' +
								formatNumber(this.y);
						} else if (customPeriod === 'week') {
							tooltipText =
								'<b>' + 'Uke' + ' ' + this.x + '</b><br/>' + 'Handler : ' + formatNumber(this.y);
						} else if (customPeriod === 'month') {
							tooltipText =
								'<b>' +
								Highcharts.dateFormat('%B - %Y', this.x) +
								'</b><br/>' +
								'Handler : ' +
								formatNumber(this.y);
						} else {
							tooltipText =
								'<b>' +
								Highcharts.dateFormat('%A, %b %e, %Y', this.x) +
								'</b><br/>' +
								'Handler : ' +
								formatNumber(this.y);
						}
						return tooltipText;
					},
				},
			});
		}

		function toggleCustomDatePicker() {
			let customDatePicker = $('.custom-date-picker');

			if (period === 'custom') {
				customDatePicker.show();
			} else {
				customDatePicker.hide();
			}
		}

		$(document).on('click', '.pagination a', function (e) {
			e.preventDefault();
			let page = parseInt($(this).attr('href').substring(6));
			getAmountOfOrderAndSale(
				startDate,
				endDate,
				period,
				supplierId,
				productGroupUniqueId,
				locationId,
				userId,
				platform,
				customPeriod,
				topProductGroupUniqueId,
				customerId,
				compareBy,
				productId,
				vatCode,
				paymentMethod,
				productCategoryId,
				null,
				page,
				1
			);
		});

		getAmountOfOrderAndSale = function (
			startDate,
			endDate,
			period = null,
			supplierId = null,
			productGroupUniqueId = null,
			locationId = 'all',
			userId = null,
			platform = 'all',
			customPeriod,
			topProductGroupUniqueId = 0,
			customerId = 0,
			compareBy = null,
			productId = 0,
			vatCode = 0,
			paymentMethod = 0,
			productCategoryId = 0,
			selectedDay = null,
			page = 1,
			getHtml = 0
		) {
			$.ajax({
				type: 'POST',
				url: '/ajax/statistic_order/search',
				data: {
					startDate,
					endDate,
					period,
					supplierId,
					productGroupUniqueId,
					locationId,
					userId,
					platform,
					customPeriod,
					topProductGroupUniqueId,
					customerId,
					compareBy,
					productId,
					vatCode,
					paymentMethod,
					productCategoryId,
					selectedDay,
					page,
					get_page_html: getHtml,
				},
			})
				.done(function (data) {
					if (!getHtml) {
						if (data.totalQuantity) {
							$('#key-figure-sale').text(data.totalQuantity);
							$('#key-figure-order').text(data.totalQuantity);
						} else {
							$('#key-figure-sale').text('0');
							$('#key-figure-order').text('0');
						}
						if (data.xAxisArray.length > 0 && data.seriesData1 && data.seriesData2) {
							exportDateData = data.xAxisArray;
							exportOrderData = data.seriesData1;
							eventLineChart(data.xAxisArray, data.seriesData1, data.seriesData2);
						}
						let aTags = $('.statistic-tab-group a');
						aTags.each(function () {
							let oldHref = $(this).attr('href').split('?')[0];
							let newHref =
								oldHref +
								`?filter_by=${period}&custom_period=${customPeriod}&prev_selected_period=${prevSelectedPeriod}&start_date=${startDate}&end_date=${endDate}`;
							$(this).prop('href', newHref);
						});
					}

					if (data && data.html !== undefined && data.html !== null && data.html !== '') {
						$('#order-list-view').html(data.html);
						if ($('body').attr('is_verifone') !== '1') {
							checkTerminalAvailability('return_order');
						}
						initDisabledTooltips();
					}
				})
				.fail(function (data) {
					if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
						document.location.href = data.responseJSON.redirect_url;
					}
				});
		};

		function displayGraphDynamically(durationOfstartAndEndDate) {
			if (isMobile) {
				if (durationOfstartAndEndDate <= 7) {
					customPeriod = 'day';
					$("#custom-period option[value='day']").prop('disabled', false);
					$("#custom-period option[value='day']").prop('selected', true);
					$("#custom-period option[value='week']").prop('disabled', false);
					$("#custom-period option[value='time']").prop('disabled', true);
					$("#custom-period option[value='time']").addClass('disabledOption');
					$("#custom-period option[value='day']").removeClass('disabledOption');
					$("#custom-period option[value='week']").removeClass('disabledOption');
				} else if (durationOfstartAndEndDate >= 8 && durationOfstartAndEndDate < 49) {
					//week
					customPeriod = 'week';
					$(`#custom-period option[value="week"]`).prop('selected', true);
					$("#custom-period option[value='week']").prop('disabled', false);
					$("#custom-period option[value='time']").prop('disabled', true);
					$("#custom-period option[value='day']").prop('disabled', true);
					$("#custom-period option[value='time']").addClass('disabledOption');
					$("#custom-period option[value='day']").addClass('disabledOption');
					$("#custom-period option[value='week']").removeClass('disabledOption');
				} else {
					//month
					customPeriod = 'month';
					$(`#custom-period option[value="week"]`).prop('selected', false);
					$(`#custom-period option[value="month"]`).prop('selected', true);
					$("#custom-period option[value='time']").prop('disabled', true);
					$("#custom-period option[value='day']").prop('disabled', true);
					$("#custom-period option[value='week']").prop('disabled', true);
					$("#custom-period option[value='time']").addClass('disabledOption');
					$("#custom-period option[value='day']").addClass('disabledOption');
					$("#custom-period option[value='week']").addClass('disabledOption');
				}
			} else if (isTablet) {
				if (durationOfstartAndEndDate <= 180) {
					//day
					customPeriod = 'day';
					$("#custom-period option[value='day']").prop('disabled', false);
					$("#custom-period option[value='day']").prop('selected', true);
					$("#custom-period option[value='week']").prop('disabled', false);
					$("#custom-period option[value='time']").prop('disabled', true);
					$("#custom-period option[value='time']").addClass('disabledOption');
					$("#custom-period option[value='day']").removeClass('disabledOption');
					$("#custom-period option[value='week']").removeClass('disabledOption');
				} else if (durationOfstartAndEndDate >= 181 && durationOfstartAndEndDate < 365) {
					//week
					customPeriod = 'week';
					$(`#custom-period option[value="week"]`).prop('selected', true);
					$("#custom-period option[value='week']").prop('disabled', false);
					$("#custom-period option[value='time']").prop('disabled', true);
					$("#custom-period option[value='day']").prop('disabled', true);
					$("#custom-period option[value='time']").addClass('disabledOption');
					$("#custom-period option[value='day']").addClass('disabledOption');
					$("#custom-period option[value='week']").removeClass('disabledOption');
				} else {
					//month
					customPeriod = 'month';
					$(`#custom-period option[value="week"]`).prop('selected', false);
					$(`#custom-period option[value="month"]`).prop('selected', true);
					$("#custom-period option[value='time']").prop('disabled', true);
					$("#custom-period option[value='day']").prop('disabled', true);
					$("#custom-period option[value='week']").prop('disabled', true);
					$("#custom-period option[value='time']").addClass('disabledOption');
					$("#custom-period option[value='day']").addClass('disabledOption');
					$("#custom-period option[value='week']").addClass('disabledOption');
				}
			} else {
				if (durationOfstartAndEndDate <= 180) {
					//day
					customPeriod = 'day';
					$("#custom-period option[value='day']").prop('disabled', false);
					$("#custom-period option[value='day']").prop('selected', true);
					$("#custom-period option[value='week']").prop('disabled', false);
					$("#custom-period option[value='time']").prop('disabled', true);
					$("#custom-period option[value='time']").addClass('disabledOption');
					$("#custom-period option[value='day']").removeClass('disabledOption');
					$("#custom-period option[value='week']").removeClass('disabledOption');
				} else if (durationOfstartAndEndDate >= 181 && durationOfstartAndEndDate < 365) {
					//week
					customPeriod = 'week';
					$(`#custom-period option[value="week"]`).prop('selected', true);
					$("#custom-period option[value='week']").prop('disabled', false);
					$("#custom-period option[value='time']").prop('disabled', true);
					$("#custom-period option[value='day']").prop('disabled', true);
					$("#custom-period option[value='time']").addClass('disabledOption');
					$("#custom-period option[value='day']").addClass('disabledOption');
					$("#custom-period option[value='week']").removeClass('disabledOption');
				} else {
					//month
					customPeriod = 'month';
					$(`#custom-period option[value="week"]`).prop('selected', false);
					$(`#custom-period option[value="month"]`).prop('selected', true);
					$("#custom-period option[value='time']").prop('disabled', true);
					$("#custom-period option[value='day']").prop('disabled', true);
					$("#custom-period option[value='week']").prop('disabled', true);
					$("#custom-period option[value='time']").addClass('disabledOption');
					$("#custom-period option[value='day']").addClass('disabledOption');
					$("#custom-period option[value='week']").addClass('disabledOption');
				}
			}
		}

		getAmountOfOrderAndSale(
			startDate,
			endDate,
			period,
			supplierId,
			productGroupUniqueId,
			locationId,
			userId,
			platform,
			customPeriod,
			topProductGroupUniqueId,
			customerId,
			compareBy,
			productId,
			vatCode,
			paymentMethod,
			productCategoryId
		);
		toggleCustomDatePicker();
	}
});
